<template>
  <div>
    <div class="py-2">
      <span><strong>Day/Hour Heatmap Usage</strong></span>
    </div>
    <VueApexCharts
      :options="heatmapDayTrendChart.options"
      :series="props.seriesData"
      height="350px"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { defineProps, computed, toRaw } from "vue";
import VueApexCharts from "vue3-apexcharts";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
  },
  categories: {
    type: Array,
    required: false,
  },
})

// eslint-disable-next-line no-unused-vars
const maxValue = computed(() => {
  let check = []
  toRaw(props.seriesData).forEach((item) => {
    check.push(...item.data)
  })
  const max = Math.max(...check.map((i) => i.y))
  return max
})

// eslint-disable-next-line no-unused-vars
const minValue = computed(() => {
  let check = []
  toRaw(props.seriesData).forEach((item) => {
    check.push(...item.data)
  })
  const min = Math.min(...check.map((i) => i.y))
  return min
})

// console.log(maxValue.value)
// console.log((maxValue.value - minValue.value) / 3)
// console.log(((maxValue.value - minValue.value) / 3) + ((maxValue.value - minValue.value) / 3))
// console.log(minValue.value)
// * Heatmap Trend data
const heatmapDayTrendChart = computed(() => {
  return {
    options: {
    chart: {
      toolbar: {
        show: true
      },
      type: 'heatmap',
    },
    plotOptions: {
      heatmap: {
        enableShades: true,
        shadeIntensity: 0.9,
        radius: 5,
        colorScale: {
          ranges: [
            {
              from: minValue.value,
              to: minValue.value + 1,
              name: 'Usage',
              color: '#2B978D'
            },
            {
              from: minValue.value + 1,
              to: maxValue.value - 1,
              name: 'Usage',
              color: '#0C1E36'
            },
            {
              from: maxValue.value,
              to: maxValue.value + 1,
              name: 'Usage',
              color: '#FD6213'
            },
          ]
        }
      }
    },
    legend: {
      show: false
    },
    dataLabels: {
      enabled: true
    },
    stroke: {
      width: 2
    },
  }}
});
</script>
